import { render, staticRenderFns } from "./work-orders-import.vue?vue&type=template&id=22cd4ea2"
import script from "./work-orders-import.vue?vue&type=script&lang=js"
export * from "./work-orders-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports